"use client"

import { ComponentConfig } from "@measured/puck"
import { commonDefaultStylesProps, commonStylesProps } from "../../../lib/commonCSSProps"
import { RenderConfig } from "./RenderConfig"
import type { EventCarouselProps } from "./types"

export const EventCarousel: ComponentConfig<EventCarouselProps> = {
  label: "Tamda OC | Event Carousel",
  fields: {
    title: {
      label: "Title",
      type: "text",
    },
    viewAllUrl: {
      label: "View All Url",
      type: "text",
    },
    ...(commonStylesProps as any),
  },
  defaultProps: {
    title: "UPCOMING EVENTS",
    ...commonDefaultStylesProps,
  },
  ...RenderConfig,
}

export type { EventCarouselProps } from "./types"
